var _a;
import { PROXY_TREE, VALUE } from 'proxy-state-tree';
const CURRENT_EXIT = Symbol('CURRENT_EXIT');
const INITIAL_STATE = Symbol('INITIAL_STATE');
const PENDING_TRANSITIONS = Symbol('PENDING_TRANSITIONS');
class StateMachine {
    constructor(transitions, definition) {
        this[_a] = {};
        this[INITIAL_STATE] = definition.state;
        Object.assign(this, definition);
        Object.keys(transitions).reduce((aggr, key) => {
            aggr[key] = function (entry, exit) {
                if (transitions[this.state].includes(key)) {
                    const tree = (this[PROXY_TREE].master.mutationTree || this[PROXY_TREE]);
                    tree.enableMutations();
                    if (this[CURRENT_EXIT])
                        this[CURRENT_EXIT]();
                    this[VALUE][CURRENT_EXIT] = exit;
                    this.state = key;
                    const result = entry && entry();
                    tree.blockMutations();
                    if (this[VALUE][PENDING_TRANSITIONS][this.state]) {
                        this[VALUE][PENDING_TRANSITIONS][this.state].forEach((resolve) => resolve());
                        this[VALUE][PENDING_TRANSITIONS][this.state] = [];
                    }
                    return result;
                }
            };
            return aggr;
        }, this);
    }
    reset() {
        const exit = this[VALUE][CURRENT_EXIT];
        if (typeof exit === 'function') {
            exit();
            this[VALUE][CURRENT_EXIT] = undefined;
        }
        this.state = this[INITIAL_STATE];
    }
    whenTransitioned(state) {
        if (!this[VALUE][PENDING_TRANSITIONS][state]) {
            this[VALUE][PENDING_TRANSITIONS][state] = [];
        }
        return new Promise((resolve) => {
            this[VALUE][PENDING_TRANSITIONS][state].push(resolve);
        });
    }
}
_a = PENDING_TRANSITIONS;
export function statemachine(definition, state) {
    return new StateMachine(definition, state);
}
//# sourceMappingURL=statemachine.js.map